import { forEachWithGitYield } from '../../git-runtime.js';
import { isGitRenameNumstatPath } from '../parse/expand-git-rename-numstat-path.js';
import type { NameStatusEntry, ParsedNumstatEntry } from '../parse/types.js';
import { buildChangedFileRow } from '../rows/build-changed-file-row.js';
import type { WorkingTreeChangeFileRow } from '../types.js';

export async function buildChangedFileRowsFromPaths(options: {
  paths: Iterable<string>;
  repoPathRelativeToWorkspaceRoot: string;
  nameByPath: Map<string, NameStatusEntry>;
  numByPath: Map<string, ParsedNumstatEntry>;
  movedSourcePaths: Set<string>;
  untrackedSet?: Set<string>;
  applyUntrackedStats?: (
    row: WorkingTreeChangeFileRow,
    filePathRelativeToRepoRoot: string,
  ) => Promise<void>;
}): Promise<WorkingTreeChangeFileRow[]> {
  const rows: WorkingTreeChangeFileRow[] = [];
  await forEachWithGitYield([...options.paths], async (filePathRelativeToRepoRoot) => {
    if (isGitRenameNumstatPath(filePathRelativeToRepoRoot)) return;
    if (options.movedSourcePaths.has(filePathRelativeToRepoRoot)) return;

    const nameEntry = options.nameByPath.get(filePathRelativeToRepoRoot);
    const numEntry = options.numByPath.get(filePathRelativeToRepoRoot);
    const row = buildChangedFileRow({
      filePathRelativeToRepoRoot,
      repoPathRelativeToWorkspaceRoot: options.repoPathRelativeToWorkspaceRoot,
      nameEntry,
      numEntry,
      untracked: options.untrackedSet?.has(filePathRelativeToRepoRoot),
    });

    if (options.applyUntrackedStats) {
      await options.applyUntrackedStats(row, filePathRelativeToRepoRoot);
    }

    rows.push(row);
  });
  return rows;
}
